import { render, staticRenderFns } from "./ImageHolder.vue?vue&type=template&id=20ad08e9&lang=pug"
import script from "./ImageHolder.vue?vue&type=script&lang=js"
export * from "./ImageHolder.vue?vue&type=script&lang=js"
import style0 from "./ImageHolder.vue?vue&type=style&index=0&id=20ad08e9&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports